import Api from "../Api";
import { useAuthStore } from "@/store/useAuthStore";

export async function getSeoData(seoPageTypeIdentifier = null)
{
    if (!useAuthStore().user?.id) return null;
    return await Api().get("/get-seo",{params: {seoPageTypeIdentifier}});
}

export async function updateSeoData(formData)
{
    return await Api().put("/seo", formData);
}

export async function getSeoSetting(pageId, pageType, agencyId)
{
    return await Api().get(`/page-seo-settings/${pageId}/${pageType}/${agencyId}`);
}

export async function getSocialSeoSetting(pageId, agencyId, pageType, socialType)
{
    return await Api().get(`/page-social-seo-settings/${pageId}/${agencyId}/${pageType}/${socialType}`);
}

export async function saveGeneralSeo(formData)
{
    return await Api().post("/page-seo-settings", formData);
}

export async function saveSocialSeo(formData)
{
    return await Api().post("/page-social-seo-settings", formData);
}

export async function deleteSocialSeo(socialId)
{
    return await Api().delete(`/page-social-seo-settings/${socialId}`);
}

export async function storeFocusKeyword(pageType, pageId, keywords)
{
    return await Api().post(`/page-social-seo-settings/focus-keyword/${pageType}/${pageId}`, {keywords:keywords});
}

export async function fetchTripDetails(tripId)
{
    return await Api().get(`/page-social-seo-settings/trip-details/${tripId}`);
    
}

export async function getRobotsRules()
{
    return await Api().get("/seo/robots");
}

export async function saveRobotsRules(customRules)
{
    return await Api().put("/seo/robots", { custom_rules: customRules });
}

export async function getRobotsLiveCheck()
{
    return await Api().get("/seo/robots/live-check");
}
